<template>

  <div class="error-notice" role="alert">
    <i class="pi pi-exclamation-triangle"></i>
    <div class="error-notice-body">
      <p class="error-notice-message">{{ message }}</p>
      <div class="error-notice-action" v-if="actionLabel" role="button" tabindex="0" @click="$emit('action')" @keydown.enter="$emit('action')">
        {{ actionLabel }}
      </div>
    </div>
  </div>

</template>


<script>
// The error box used on the AI tool and settings pages, shown under the page heading. (Not class="error":
// App.vue has a global .error style that pins it to the top of the page.)
export default {
  name: 'ErrorNotice',
  props: {
    message: { type: String, required: true },
    actionLabel: { type: String, default: '' }
  }
}
</script>


<style scoped>

.error-notice {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 12px;
  box-sizing: border-box;
  margin: 20px 0px;
  padding: 14px 16px;
  background-color: #fdecea;
  border: 1px solid #f5c2bd;
  border-left: 4px solid #BE1E2D;
  border-radius: 6px;
  color: #5f1218;
}

.error-notice i {
  font-size: 18px;
  color: #BE1E2D;
  margin-top: 1px;
  flex-shrink: 0;
}

.error-notice-body {
  min-width: 0;
}

.error-notice-message {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  margin: 0px;
}

.error-notice-action {
  display: inline-block;
  margin-top: 10px;
  font-size: 13px;
  font-weight: 600;
  padding: 7px 14px;
  border-radius: 5px;
  background-color: #BE1E2D;
  color: white;
  cursor: pointer;
}

</style>
